import styled from 'styled-components';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SectionTitle = styled.h3<{ spacing?: number }>(
  ({ theme, spacing }) => `
  color: ${theme.colors.primary};
  margin-bottom: ${spacing !== undefined ? spacing : theme.spacing.small}px;
  vertical-align: middle;
  font-size: ${theme.font.size.smallMedium};
  @media only screen and ${theme.device.laptop} {
    font-size: ${theme.font.size.medium3};
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export default SectionTitle;
